import { render, staticRenderFns } from "./LegalDocuments.vue?vue&type=template&id=8617f238&"
import script from "./LegalDocuments.vue?vue&type=script&lang=js&"
export * from "./LegalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocuments.vue?vue&type=style&index=0&id=8617f238&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports